import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=2794281a&"
import script from "./Header.ts?vue&type=script&lang=js&"
export * from "./Header.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports